<script setup lang="ts">
const { locale: i18nLocale } = useI18n();

// Handle Back-Forward Cache (bfcache) - when the browser restores the page from memory
// only sync the i18n locale with the cookie value
onMounted(() => {
  window.addEventListener('pageshow', (event) => {
    // Only handle bfcache restore (event.persisted = true)
    if (event.persisted) {
      const cookieLocale = getCookie('i18n_redirected') ?? 'en';

      // If the current i18n locale does not match the cookie, just update it
      if (i18nLocale.value !== cookieLocale) {
        i18nLocale.value = cookieLocale;
      }
    }
  });
});
</script>

<template>
   <div>
     <NuxtPage />
     <PickerBackdrop />
  </div>
</template>

<style>
.page-enter-active,
.page-leave-active {
  transition: all 0.1s;
}
.page-enter-from,
.page-leave-to {
  opacity: 0;
  position: absolute;
  filter: blur(1rem);
}
</style>